import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { NewsPage } from './pages/NewsPage';
import { NewsArticlePage } from './pages/NewsArticlePage';
import { EvenementsPage } from './pages/EvenementsPage';
import { EventDetailPage } from './pages/EventDetailPage';
import { EmploiPage } from './pages/EmploiPage';
import { FormationPage } from './pages/FormationPage';
import { ContactPage } from './pages/ContactPage';
import { MembresCAPage } from './pages/MembresCAPage';
import { StatutsPage } from './pages/StatutsPage';
import { CommentAdhererPage } from './pages/CommentAdhererPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);
  useEffect(() => {
    const handleNavigation = () => {
      setCurrentPath(window.location.pathname);
    };
    // Handle browser back/forward buttons
    window.addEventListener('popstate', handleNavigation);
    // Handle link clicks
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a');
      if (link && link.href.startsWith(window.location.origin)) {
        const url = new URL(link.href);
        if (!link.target && !link.hasAttribute('download')) {
          e.preventDefault();
          window.history.pushState({}, '', url.pathname);
          setCurrentPath(url.pathname);
          window.scrollTo(0, 0);
        }
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('popstate', handleNavigation);
      document.removeEventListener('click', handleClick);
    };
  }, []);
  // Route matching
  if (currentPath === '/news') return <NewsPage data-id="element-0" />;
  if (currentPath.startsWith('/news/')) return <NewsArticlePage data-id="element-1" />;
  if (currentPath === '/evenements') return <EvenementsPage data-id="element-2" />;
  if (currentPath.startsWith('/evenements/')) return <EventDetailPage data-id="element-3" />;
  if (currentPath === '/emploi') return <EmploiPage data-id="element-4" />;
  if (currentPath === '/formation') return <FormationPage data-id="element-5" />;
  if (currentPath === '/contact-us') return <ContactPage data-id="element-6" />;
  if (currentPath === '/membres-ca') return <MembresCAPage data-id="element-7" />;
  if (currentPath === '/statuts') return <StatutsPage data-id="element-8" />;
  if (currentPath === '/comment-adherer') return <CommentAdhererPage data-id="element-9" />;
  return <HomePage data-id="element-10" />;
}